module.exports = __webpack_public_path__ + "img/tosspay.470d5e51.png";